import React, { useCallback, useState } from 'react';
import { Icon } from '@shakkerai/components';
import { translate } from '@shakkerai/util-i18n';
import { mc } from '@shakkerai/report';

import { getActiveGeneratorId, uploadImage } from '@shakkerai/pro-utils';
import { applyReferenceImage } from '@starflow/app/modules/generator/helpers';
import { applyImg2ImgSourceImage } from '@starflow/app/modules/generator/helpers';

import { setTempState } from '@starflow/app/store';
import { applyColorReferenceFromImg } from '@starflow/app/modules/generator/helpers';
import helpers from '@starflow/app/helpers';

export const ImageTool = React.memo(({ element }) => {
  const uploadImg = async () => {
    const node = helpers.canvas.getCanvasStage().findOne(`#${element.id}-${element.data.shape}`);
    const blob = await node.toBlob();
    const file = new File([blob], `${element.id}.png`, { type: blob.type });
    const result = await uploadImage(file);
    await helpers.canvas.updateElement(element.id, { url: result.url, imageUrl: result.url });
    return Promise.resolve({ url: result.url, imageUrl: result.url });
  };

  const handleSendToReference = useCallback(async () => {
    const res = await uploadImg();
    mc('tool.canvas.reference', { image_id: element.innerImageId });
    applyReferenceImage(
      {
        ...element,
        ...res,
      },
      getActiveGeneratorId(),
    );
  }, [element]);

  const handleSendToColorReference = useCallback(async () => {
    const res = await uploadImg();
    applyColorReferenceFromImg({
      ...element,
      ...res,
    });
  }, [element]);

  const handleSendToImg2Img = useCallback(
    async (event) => {
      const res = await uploadImg();
      const generatorId = getActiveGeneratorId();
      mc('tool.canvas.img2img', { image_id: element.innerImageId });
      applyImg2ImgSourceImage(
        {
          ...element,
          ...res,
        },
        generatorId,
      );
      setTempState('exclusiveWindow', `image-input-options-${generatorId}`);

      event.stopPropagation();
    },
    [element],
  );

  return (
    <div className={`group relative image-tool-btn w-[66px] text-[12px] mr-[0]`}>
      {translate('image_tool_use_image')}
      <Icon className="shk-kuangjia-xiala -mr-2" color="#666" fontSize={18} />
      <div className="absolute hidden group-hover:block left-0 top-[24px] flex flex-col items-stretch rounded-sm bg-[#2c2c2c] py-1.5 px-0 w-[178px]">
        <button
          onClick={handleSendToImg2Img}
          className="flex flex-col w-full px-3 py-1.5 text-white hover:bg-primary hover:text-[#2c2c2c]"
        >
          <span className="text-xs leading-[16px] font-semibold">{translate('img_use_as_i2i_title')}</span>
          <span className="mt-1 leading-[12px] text-[11px]">{translate('img_use_as_i2i_desc')}</span>
        </button>
        <button
          onClick={handleSendToReference}
          className="flex flex-col w-full px-3 py-1.5 text-white hover:bg-primary hover:text-[#2c2c2c] disabled:pointer-events-none disabled:opacity-30"
        >
          <span className="text-xs leading-[16px] font-semibold">{translate('img_use_as_ref_title')}</span>
          <span className="mt-1 leading-[12px] text-[11px]">{translate('img_use_as_ref_desc')}</span>
        </button>
        <button
          onClick={handleSendToColorReference}
          className="flex flex-col w-full px-3 py-1.5 text-white hover:bg-primary hover:text-[#2c2c2c] disabled:pointer-events-none disabled:opacity-30"
        >
          <span className="text-xs leading-[16px] font-semibold">{translate('color_canvas_para1')}</span>
          <span className="mt-1 leading-[12px] text-[11px]">{translate('color_canvas_para2')}</span>
        </button>
      </div>
    </div>
  );
});
